import { atom, useAtom } from 'jotai';
import React from 'react';

import * as S from './MultiStepForm.style';

export const multiFormStepAtom = atom(0);

type MultiStepFormProps = {
  elements: React.ReactNode[];
  diabledNextBtn?: boolean[];
  maxStep: number;
  lastStepBtnString?: string;
  onSubmit: () => void;
};
const MultiStepForm = ({
  elements,
  diabledNextBtn = Array(elements.length).fill(false),
  maxStep,
  lastStepBtnString,
  onSubmit,
}: MultiStepFormProps) => {
  const [step, setStep] = useAtom(multiFormStepAtom);
  const onClickNext = () => {
    if (step === maxStep) {
      return;
    }
    setStep(step + 1);
  };
  const onClickPrev = () => {
    if (step === 0) {
      return;
    }
    setStep(step - 1);
  };

  return (
    <S.Container>
      {elements[step]}
      <S.BtnWrapper>
        {step > 0 && <S.PrevBtn onClick={onClickPrev}>이전</S.PrevBtn>}
        {step < elements.length - 1 && (
          <S.NextBtn onClick={onClickNext} disabled={diabledNextBtn[step]}>
            다음
          </S.NextBtn>
        )}
        {step === elements.length - 1 && (
          <S.NextBtn onClick={onSubmit}>{lastStepBtnString}</S.NextBtn>
        )}
      </S.BtnWrapper>
    </S.Container>
  );
};
export default MultiStepForm;
